// symbols.ts
var fieldParentSymbol = Symbol("fieldParentProtoReference");
var upgradeMark = Symbol("upgraded");
var noChangeRecorded = Symbol("noChangeRecorded");
var fromNetwork = Symbol("fromNetwork");
var bqlScalar = Symbol("baseqlScalar");
var _manualUpdate = "___manualUpdate";
var operationName = Symbol("operationName");
export {
  _manualUpdate,
  bqlScalar,
  fieldParentSymbol,
  fromNetwork,
  noChangeRecorded,
  operationName,
  upgradeMark
};
